import React, { useEffect } from "react";
import {  BtnPrimary, BtnGhost, BgDecorations, GlobalStyles, Nav, Brand } from "../components/UI";
import { ACCENT, ACCENT2, BORDER, MUTED, CARD_BG } from "../utils/constants";

function QRMockup() {
  const p = [1,1,1,1,1,1,1,1,0,0,0,0,0,1,1,0,1,0,1,0,1,1,0,0,0,0,0,1,1,0,1,0,1,0,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1];
  return (
    <div style={{ width: 180, height: 180, background: "#fff", borderRadius: 12, display: "grid", gridTemplateColumns: "repeat(7,1fr)", gridTemplateRows: "repeat(7,1fr)", gap: 3, padding: 12 }}>
      {p.map((v, i) => <div key={i} style={{ borderRadius: 2, background: v ? "#111" : "transparent" }} />)}
    </div>
  );
}

function ProfilePreviewCard() {
  const tag = (bg, color, t) => <span style={{ display: "inline-block", padding: "3px 10px", borderRadius: 100, fontSize: 11, fontWeight: 500, background: bg, color }}>{t}</span>;
  return (
    <div style={{ background: CARD_BG, border: `1px solid ${BORDER}`, borderRadius: 22, padding: 24, maxWidth: 320, width: "100%", flexShrink: 0 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
        <div style={{ width: 46, height: 46, borderRadius: "50%", background: `linear-gradient(135deg,${ACCENT},${ACCENT2})`, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Syne,sans-serif", fontWeight: 700, fontSize: 16, color: "#fff" }}>RS</div>
        <div>
          <div style={{ fontFamily: "Syne,sans-serif", fontSize: 15, fontWeight: 600, color: "#fff" }}>Rahul Sharma</div>
          <div style={{ fontSize: 11, color: MUTED, marginTop: 1 }}>RQ-2025-X7K2MN</div>
        </div>
      </div>
      <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginBottom: 4 }}>
        {tag("rgba(226,75,74,0.15)","#ff8b8a","🩸 B+")}
        {tag("rgba(99,153,34,0.15)","#9fd45a","Diabetic — Type 2")}
        {tag("rgba(55,138,221,0.15)","#85b7eb","BP: 130/85")}
      </div>
      <div style={{ borderTop: `1px solid ${BORDER}`, margin: "10px 0" }} />
      {[["DOB","12 Mar 1978"],["Gender","Male"],["Address","Lucknow, UP"]].map(([l,v]) => (
        <div key={l} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0" }}>
          <span style={{ color: MUTED, fontSize: 12 }}>{l}</span>
          <span style={{ color: "#fff", fontSize: 12, fontWeight: 500 }}>{v}</span>
        </div>
      ))}
      <div style={{ marginTop: 12, background: "rgba(124,111,255,0.08)", border: "1px solid rgba(124,111,255,0.2)", borderRadius: 10, padding: 10, display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ width: 30, height: 30, borderRadius: "50%", background: ACCENT, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13 }}>📞</div>
        <div>
          <div style={{ fontSize: 12, fontWeight: 500, color: "#fff" }}>Priya Sharma (Wife)</div>
          <div style={{ fontSize: 11, color: MUTED }}>+91 98765 43210</div>
        </div>
      </div>
      <button style={{ marginTop: 11, width: "100%", background: `linear-gradient(135deg,${ACCENT},${ACCENT2})`, border: "none", borderRadius: 100, padding: "10px", color: "#fff", fontSize: 13, fontWeight: 500, cursor: "pointer", fontFamily: "DM Sans,sans-serif" }}>📞 Call Emergency Contact</button>
    </div>
  );
}

export default function Landing({ onStart, price = 199, priceLoading = false }) {
  useEffect(() => { document.title = `DialHoop — Emergency QR Medical ID Card | ₹${price} Shipped`; }, [price]);

  const displayPrice = priceLoading ? "…" : `₹${price}`;

  const navRight = (
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <div className="nav-links" style={{ display: "flex", gap: 22 }}>
        {[["#features","Features"],["#how","How it works"],["#preview","Preview"]].map(([h,l]) => (
          <a key={h} href={h} style={{ color: MUTED, fontSize: 14 }}>{l}</a>
        ))}
      </div>
      <button
        onClick={onStart}
        style={{ background: `linear-gradient(135deg,${ACCENT},${ACCENT2})`, color: "#fff", border: "none", padding: "10px 20px", borderRadius: 100, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "DM Sans,sans-serif", whiteSpace: "nowrap" }}
      >
        Order · {displayPrice}
      </button>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: "#080B18", color: "#F0EEF8", fontFamily: "DM Sans, sans-serif", overflowX: "hidden", position: "relative" }}>
      <BgDecorations />
      <Nav right={navRight} />

      {/* HERO */}
      <section style={{ position: "relative", zIndex: 1, minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "110px 20px 60px" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 8, border: "1px solid rgba(124,111,255,0.35)", background: "rgba(124,111,255,0.08)", color: "#a89fff", fontSize: 12, fontWeight: 500, letterSpacing: "0.8px", textTransform: "uppercase", padding: "6px 16px", borderRadius: 100, marginBottom: 28, animation: "fadeUp .7s ease both" }}>
          <div style={{ width: 6, height: 6, borderRadius: "50%", background: ACCENT, boxShadow: `0 0 8px ${ACCENT}`, animation: "pulse 2s ease-in-out infinite" }} />
          Emergency Identity Platform
        </div>

        <h1 style={{ fontFamily: "Syne, sans-serif", fontSize: "clamp(32px,7vw,78px)", fontWeight: 800, lineHeight: 1.05, letterSpacing: "-0.03em", color: "#fff", maxWidth: 820, margin: "0 auto 0", animation: "fadeUp .7s .1s ease both" }}>
          Your life info,{" "}
          <span style={{ background: "linear-gradient(135deg,#a89fff 0%,#ff9dc8 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
            one scan away
          </span>
        </h1>

        <p style={{ marginTop: 18, fontSize: 17, color: MUTED, maxWidth: 460, lineHeight: 1.7, animation: "fadeUp .7s .2s ease both" }}>
          A laminated QR card shipped to your door. First responders scan instantly — no app, no login.
        </p>

        {/* Price pill */}
        <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(124,111,255,0.1)", border: "1px solid rgba(124,111,255,0.25)", borderRadius: 100, padding: "8px 18px", marginTop: 20, animation: "fadeUp .7s .25s ease both", flexWrap: "wrap", justifyContent: "center" }}>
          <span style={{ fontSize: 20 }}>💳</span>
          <span style={{ fontSize: 16, color: "#fff", fontWeight: 700 }}>{displayPrice}</span>
          <span style={{ fontSize: 13, color: MUTED }}>· One-time · Lifetime profile · Free shipping</span>
        </div>

        <div className="hero-actions" style={{ display: "flex", gap: 12, marginTop: 28, flexWrap: "wrap", justifyContent: "center", animation: "fadeUp .7s .3s ease both" }}>
          <BtnPrimary onClick={onStart} style={{ fontSize: 16, padding: "15px 32px" }}>
            Order Your Card — {displayPrice} →
          </BtnPrimary>
          <BtnGhost as="a" href="#preview" style={{ padding: "14px 22px" }}>See sample profile</BtnGhost>
        </div>

        {/* Floating QR */}
        <div className="qr-float" style={{ marginTop: 52, width: 216, animation: "fadeUp .7s .4s ease both, floatY 5s ease-in-out infinite" }}>
          <div style={{ background: "rgba(255,255,255,0.06)", border: `1px solid ${BORDER}`, borderRadius: 20, padding: 20, backdropFilter: "blur(20px)" }}>
            <QRMockup />
            <div style={{ marginTop: 10, textAlign: "center", fontSize: 12, color: MUTED }}>
              <strong style={{ color: "#fff" }}>DialHoop</strong> · Scan to view profile
            </div>
          </div>
        </div>
      </section>

      {/* STATS */}
      <div className="stats-row" style={{ position: "relative", zIndex: 1, display: "flex", justifyContent: "center", padding: "0 20px 72px", flexWrap: "wrap" }}>
        {[
          { num: displayPrice,  label: "One-time, no renewals" },
          { num: "Physical",    label: "Laminated card shipped" },
          { num: "Instant",     label: "No app required to scan" },
          { num: "Lifetime",    label: "Profile stays active" },
        ].map((st, i, arr) => (
          <div key={i} className="stat-item" style={{ padding: "20px 36px", textAlign: "center", borderRight: i < arr.length - 1 ? `1px solid ${BORDER}` : "none" }}>
            <div style={{ fontFamily: "Syne,sans-serif", fontSize: 28, fontWeight: 700, background: "linear-gradient(135deg,#fff 0%,#a89fff 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>{st.num}</div>
            <div style={{ fontSize: 13, color: MUTED, marginTop: 3 }}>{st.label}</div>
          </div>
        ))}
      </div>

      {/* FEATURES */}
      <section id="features" style={{ position: "relative", zIndex: 1, maxWidth: 1100, margin: "0 auto", padding: "72px 20px" }}>
        <div style={{ fontSize: 12, fontWeight: 600, letterSpacing: 1, textTransform: "uppercase", color: "#a89fff", marginBottom: 14 }}>Everything you need</div>
        <div style={{ fontFamily: "Syne,sans-serif", fontWeight: 700, fontSize: "clamp(22px,4vw,42px)", lineHeight: 1.15, letterSpacing: "-0.03em", color: "#fff", maxWidth: 520, marginBottom: 44 }}>Built for the moment that matters most</div>
        <div className="feat-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 14 }}>
          {[
            { span:2, icon:"⚡", bg:"rgba(124,111,255,0.15)", title:"Instant Emergency Profile", desc:"Your blood group, medical conditions, and emergency contacts surface immediately when someone scans your QR — no login, no friction, just the critical information that can save your life." },
            { span:1, icon:"📦", bg:"rgba(255,107,157,0.15)", title:"Physical Card Shipped", desc:"Laminated, wallet-sized card delivered to your address. Keep it in your wallet, bag, or helmet." },
            { span:1, icon:"📱", bg:"rgba(29,158,117,0.15)", title:"No App Needed", desc:"Anyone with a phone can scan. No downloads, no accounts required." },
            { span:1, icon:"🩺", bg:"rgba(239,159,39,0.15)", title:"Medical Details", desc:"Blood group, diabetes, blood pressure — all vitals that matter in emergencies." },
            { span:1, icon:"🆔", bg:"rgba(124,111,255,0.15)", title:"Unique Member ID", desc:"Every profile gets a unique DialHoop ID for quick identification." },
          ].map((f,i) => (
            <div key={i} className={f.span===2?"feat-span2":""} style={{ gridColumn:`span ${f.span}`, background:CARD_BG, border:`1px solid ${BORDER}`, borderRadius:18, padding:24 }}>
              <div style={{ width:40, height:40, borderRadius:10, background:f.bg, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18, marginBottom:16 }}>{f.icon}</div>
              <div style={{ fontFamily:"Syne,sans-serif", fontSize:16, fontWeight:600, color:"#fff", marginBottom:7 }}>{f.title}</div>
              <div style={{ fontSize:14, color:MUTED, lineHeight:1.65 }}>{f.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section id="how" style={{ position: "relative", zIndex: 1, maxWidth: 1100, margin: "0 auto", padding: "20px 20px 72px" }}>
        <div style={{ fontSize: 12, fontWeight: 600, letterSpacing: 1, textTransform: "uppercase", color: "#a89fff", marginBottom: 14 }}>How it works</div>
        <div style={{ fontFamily: "Syne,sans-serif", fontWeight: 700, fontSize: "clamp(22px,4vw,42px)", lineHeight: 1.15, letterSpacing: "-0.03em", color: "#fff", maxWidth: 520, marginBottom: 44 }}>From order to your wallet in days</div>
        <div className="steps-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)" }}>
          {[
            { n:"1", title:"Fill your details",  desc:"Name, DOB, blood group, medical info, emergency contacts, delivery address." },
            { n:"2", title:`Pay ${displayPrice}`, desc:"One-time, no subscription. Secure checkout." },
            { n:"3", title:"We make your card",  desc:"We generate your QR, print and laminate your personalised card." },
            { n:"4", title:"Delivered to you",   desc:"Your physical card arrives. Scan-ready, lifetime profile." },
          ].map((st,i,arr) => (
            <div key={i} className="step" style={{ padding:"24px 18px", textAlign:"center", borderRight: i<arr.length-1?`1px solid ${BORDER}`:"none" }}>
              <div style={{ width:36, height:36, borderRadius:"50%", background:`linear-gradient(135deg,${ACCENT},${ACCENT2})`, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"Syne,sans-serif", fontSize:14, fontWeight:700, color:"#fff", margin:"0 auto 12px" }}>{st.n}</div>
              <div style={{ fontFamily:"Syne,sans-serif", fontSize:14, fontWeight:600, color:"#fff", marginBottom:6 }}>{st.title}</div>
              <div style={{ fontSize:13, color:MUTED, lineHeight:1.6 }}>{st.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* PREVIEW */}
      <section id="preview" style={{ position: "relative", zIndex: 1, maxWidth: 1100, margin: "0 auto", padding: "0 20px 72px" }}>
        <div className="preview-flex" style={{ display: "flex", gap: 56, alignItems: "center", flexWrap: "wrap" }}>
          <div style={{ flex:1, minWidth:260 }}>
            <div style={{ fontSize:12, fontWeight:600, letterSpacing:1, textTransform:"uppercase", color:"#a89fff", marginBottom:14 }}>Live profile preview</div>
            <div style={{ fontFamily:"Syne,sans-serif", fontWeight:700, fontSize:"clamp(22px,4vw,42px)", lineHeight:1.15, letterSpacing:"-0.03em", color:"#fff", maxWidth:400, marginBottom:16 }}>What responders see instantly</div>
            <p style={{ color:MUTED, fontSize:15, lineHeight:1.7, marginBottom:24 }}>Clean, fast-loading. No confusion, no app. Everything they need in one scan.</p>
            <BtnPrimary onClick={onStart} style={{ fontSize:14, padding:"12px 22px" }}>Order yours for {displayPrice} →</BtnPrimary>
          </div>
          <ProfilePreviewCard />
        </div>
      </section>

      {/* CTA */}
      <div className="cta-section" style={{ position:"relative", zIndex:1, margin:"40px auto 80px", maxWidth:840, background:"linear-gradient(135deg,rgba(124,111,255,0.12),rgba(255,107,157,0.08))", border:"1px solid rgba(124,111,255,0.2)", borderRadius:28, padding:"60px 40px", textAlign:"center", overflow:"hidden" }}>
        <div style={{ position:"absolute", top:-60, left:"50%", transform:"translateX(-50%)", width:260, height:260, borderRadius:"50%", background:"radial-gradient(circle,rgba(124,111,255,0.15),transparent 70%)", pointerEvents:"none" }} />
        <div style={{ fontFamily:"Syne,sans-serif", fontSize:"clamp(22px,4vw,44px)", fontWeight:800, letterSpacing:"-0.03em", color:"#fff", position:"relative", marginBottom:12 }}>Your identity. Always accessible.</div>
        <div style={{ fontSize:15, color:MUTED, position:"relative", marginBottom:28 }}>{displayPrice} · Physical laminated card · Shipped to your door · Lifetime digital profile</div>
        <BtnPrimary onClick={onStart} style={{ fontSize:17, padding:"16px 40px" }}>Order Your Card — {displayPrice} →</BtnPrimary>
      </div>

      {/* FOOTER */}
      <footer className="footer-row" style={{ position:"relative", zIndex:1, borderTop:`1px solid ${BORDER}`, padding:"24px 32px", display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:13, color:MUTED, flexWrap:"wrap", gap:12 }}>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <Brand size={28} />
         </div>
        <div>© 2026 DialHoop · Emergency Identity Platform · support@dialhoop.com</div>
        <div style={{ display:"flex", gap:20 }}>
          {["Privacy","Terms","Contact"].map(l => <a key={l} href="#" style={{ color:MUTED }}>{l}</a>)}
        </div>
      </footer>

      <GlobalStyles />
    </div>
  );
}
